import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { fontWeights } from '@gumtree/ui-library/src/base/theme';

import { Field } from '@gumtree/ui-library';
import Dropdown from './dropdown';
import { FilterItemProps } from './multi-select-group';
import { ApplyButton } from './dropdown.style';

const PriceInput = styled.div`
    padding: 16px;
    label {
        font-weight: ${fontWeights.light};
    }
    .price-dropdown-menu {
        width: 375px;
    }
    .input-row {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .to {
        padding-top: 10px;
    }
    .form-element input {
        padding-left: 24px;
    }
    .form-element:after {
        content: '£';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 12px;
    }
`;

const PrizeDropdown: React.FC<FilterItemProps> = (props) => {
    const { value, onChange, placeholder, label, onMenuVisibleChange } = props;
    const [price, setPrice] = useState<{ min?: string; max?: number }>(value || {});

    useEffect(() => {
        if (value?.min !== price.min || value?.max !== price.max) {
            setPrice(value || {});
        }
    }, [value]);
    const onInput = (value, key) => {
        setPrice((pre) => ({
            ...pre,
            [key]: value,
        }));
    };
    const apply = () => {
        onChange(price);
    };
    return (
        <Dropdown
            placeholder={label || placeholder}
            value={value}
            dropdownMenuCss={css`
                width: 375px;
            `}
            onMenuVisibleChange={onMenuVisibleChange}
            renderOptions={({ closeDropdown }) => {
                return (
                    <PriceInput>
                        <div className="input-row">
                            <Field
                                id="filter-multi-price-min"
                                label="Min."
                                inputMode="decimal"
                                value={price.min}
                                type="number"
                                onInput={(e) => onInput(e.currentTarget.value, 'min')}
                            />
                            <span className="to">to</span>
                            <Field
                                id="filter-multi-price-max"
                                label="Max."
                                inputMode="decimal"
                                type="number"
                                value={price.max}
                                onInput={(e) => onInput(e.currentTarget.value, 'max')}
                            />
                        </div>
                        <ApplyButton
                            css={css`
                                width: 100%;
                            `}
                            display="primary"
                            label="Apply"
                            onClick={() => {
                                apply();
                                closeDropdown();
                            }}
                            fullWidth
                        />
                    </PriceInput>
                );
            }}
        />
    );
};

export default PrizeDropdown;
